import { axios } from '../../clients/axios'
import nodeFormData from 'form-data'
import { dayjs, MMDDYYYY } from '../../util/date'

const violationHeaders = [
  { value: 'refNo', text: 'Violation ID' },
  { value: 'date', text: 'Date' },
  { value: 'tenantName', text: 'Tenant', width: '40%' },
  { value: 'description', text: 'Description' },
  { value: 'paymentId', text: 'Payment ID' },
  { value: 'attachments', text: 'Attachments' }
]

const userViolationHeaders = [
  { value: 'refNo', text: 'Violation ID' },
  { value: 'date', text: 'Date' },
  { value: 'description', text: 'Description' },
  { value: 'paymentId', text: 'Payment ID' },
  { value: 'attachments', text: 'Attachments' }
]

export default {
  namespaced: true,
  state: {
    violations: []
  },
  getters: {
    getViolations: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      let parsedViolations = []
      // let reservations = state.reservations
      state.violations.map((raw) => {
        const alias = aliases.find((a) => a.tenantId === raw.tenantId)
        let violation = {}
        const paymentDetails = raw.payment_details
        violation.violationId = raw.violationId
        violation.refNo = raw.refNo
        violation.date = dayjs(raw.date).format(MMDDYYYY)
        violation.tenantName = (alias && alias.name) || getTenantName(raw)
        violation.description = raw.description
        violation.paymentId = raw.paymentId
        violation.attachments = raw.attachments
        violation.payment_details = paymentDetails
        violation.bedId = raw.bedId
        // some payments do not have a lease associated to them
        violation.bedName =
          (paymentDetails.lease_details &&
            paymentDetails.lease_details.bed_details.bedName) ||
          'N/A'
        violation.userName = raw.tenant_details.username
        parsedViolations.push(violation)
      })

      return parsedViolations
    },
    getHeaders: () => {
      return violationHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true

        return header
      })
    },
    getUserViolationHeaders: () => {
      return userViolationHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true

        return header
      })
    }
  },
  mutations: {
    fetchViolations(state, violations) {
      state.violations = violations
    }
  },
  actions: {
    async fetchViolationsAction(context, params) {
      const { page, limit, sortBy, sortDesc, search } = params
      let uri = `${
        process.env.VUE_APP_API_URL
      }/violations/search?limit=${limit}&page=${page - 1}`

      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (search) {
        uri += `&search=${JSON.stringify(search)}`
      }
      const violations = await axios.get(uri, { withCredentials: true })

      context.commit('fetchViolations', violations.data.data)
      return {
        limit: limit,
        count: violations.data.count
      }
    },
    async newViolationAction(context, params) {
      try {
        const { tenantId, description, date, attachments } = params
        const form = new nodeFormData()

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('tenantId', tenantId)
        form.append('description', description)
        form.append('date', date)

        const violation = await axios.post(
          `${process.env.VUE_APP_API_URL}/violations`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(violation)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async fetchSelectedUserViolationsAction(context, params) {
      const { page, limit, sortBy, sortDesc, tenantId } = params

      let uri = `${
        process.env.VUE_APP_API_URL
      }/violations/search?limit=${limit}&page=${page - 1}`

      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (tenantId) {
        uri += `&tenantId=${tenantId}`
      }
      const violations = await axios.get(uri, { withCredentials: true })

      context.commit('fetchViolations', violations.data.data)

      return {
        limit: limit,
        count: violations.data.count
      }
    }
  }
}

const getTenantName = (raw) => {
  if (raw.tenant_details.firstName && raw.tenant_details.lastName) {
    return raw.tenant_details.firstName + ' ' + raw.tenant_details.lastName
  } else {
    return raw.tenant_details.username
  }
}
